import { render } from "./aio-login-app.vue?vue&type=template&id=8fba4a60&scoped=true"
import script from "./aio-login-app.vue?vue&type=script&lang=js"
export * from "./aio-login-app.vue?vue&type=script&lang=js"

import "./aio-login-app.vue?vue&type=style&index=0&id=8fba4a60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fba4a60"]])

export default __exports__